// Generated by npm run calendar:generate. Do not edit manually.
export const approvedProductionCalendars = [
  {
    "schemaVersion": "1.0.0",
    "jurisdiction": "RU",
    "scope": "federal",
    "workweek": "five-day-mon-fri",
    "year": 2026,
    "status": "approved",
    "lastVerifiedAt": "2026-07-18",
    "sources": [
      {
        "id": "ru-labour-code-112",
        "kind": "law",
        "title": "Трудовой кодекс Российской Федерации, статья 112",
        "url": "https://pravo.gov.ru/proxy/ips/?docbody=&nd=102074279"
      },
      {
        "id": "ru-government-resolution-1466-2025",
        "kind": "resolution",
        "title": "Постановление Правительства РФ от 24.09.2025 № 1466",
        "url": "https://publication.pravo.gov.ru/document/0001202509240023"
      },
      {
        "id": "ru-government-resolution-1466-card",
        "kind": "cross-check",
        "title": "Карточка постановления № 1466 на government.ru",
        "url": "https://government.ru/docs/all/161028/"
      },
      {
        "id": "ru-government-2026-explanation",
        "kind": "cross-check",
        "title": "Пояснение Правительства РФ о выходных днях в 2026 году",
        "url": "https://government.ru/news/56309/"
      }
    ],
    "days": [
      {
        "date": "2026-01-01",
        "status": "non-working",
        "sourceRefs": [
          "ru-labour-code-112"
        ]
      },
      {
        "date": "2026-01-02",
        "status": "non-working",
        "sourceRefs": [
          "ru-labour-code-112"
        ]
      },
      {
        "date": "2026-01-03",
        "status": "non-working",
        "sourceRefs": [
          "ru-labour-code-112",
          "ru-government-resolution-1466-2025"
        ]
      },
      {
        "date": "2026-01-04",
        "status": "non-working",
        "sourceRefs": [
          "ru-labour-code-112",
          "ru-government-resolution-1466-2025"
        ]
      },
      {
        "date": "2026-01-05",
        "status": "non-working",
        "sourceRefs": [
          "ru-labour-code-112"
        ]
      },
      {
        "date": "2026-01-06",
        "status": "non-working",
        "sourceRefs": [
          "ru-labour-code-112"
        ]
      },
      {
        "date": "2026-01-07",
        "status": "non-working",
        "sourceRefs": [
          "ru-labour-code-112"
        ]
      },
      {
        "date": "2026-01-08",
        "status": "non-working",
        "sourceRefs": [
          "ru-labour-code-112"
        ]
      },
      {
        "date": "2026-01-09",
        "status": "non-working",
        "sourceRefs": [
          "ru-government-resolution-1466-2025"
        ]
      },
      {
        "date": "2026-01-10",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-01-11",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-01-12",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-01-13",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-01-14",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-01-15",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-01-16",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-01-17",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-01-18",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-01-19",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-01-20",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-01-21",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-01-22",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-01-23",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-01-24",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-01-25",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-01-26",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-01-27",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-01-28",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-01-29",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-01-30",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-01-31",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-01",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-02",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-03",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-04",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-05",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-06",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-07",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-08",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-09",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-10",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-11",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-12",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-13",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-14",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-15",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-16",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-17",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-18",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-19",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-20",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-21",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-22",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-23",
        "status": "non-working",
        "sourceRefs": [
          "ru-labour-code-112"
        ]
      },
      {
        "date": "2026-02-24",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-25",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-26",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-27",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-02-28",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-01",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-02",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-03",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-04",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-05",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-06",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-07",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-08",
        "status": "non-working",
        "sourceRefs": [
          "ru-labour-code-112"
        ]
      },
      {
        "date": "2026-03-09",
        "status": "non-working",
        "sourceRefs": [
          "ru-labour-code-112"
        ]
      },
      {
        "date": "2026-03-10",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-11",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-12",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-13",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-14",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-15",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-16",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-17",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-18",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-19",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-20",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-21",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-22",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-23",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-24",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-25",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-26",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-27",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-28",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-29",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-30",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-03-31",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-01",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-02",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-03",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-04",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-05",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-06",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-07",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-08",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-09",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-10",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-11",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-12",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-13",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-14",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-15",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-16",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-17",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-18",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-19",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-20",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-21",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-22",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-23",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-24",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-25",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-26",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-27",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-28",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-29",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-04-30",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-01",
        "status": "non-working",
        "sourceRefs": [
          "ru-labour-code-112"
        ]
      },
      {
        "date": "2026-05-02",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-03",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-04",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-05",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-06",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-07",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-08",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-09",
        "status": "non-working",
        "sourceRefs": [
          "ru-labour-code-112"
        ]
      },
      {
        "date": "2026-05-10",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-11",
        "status": "non-working",
        "sourceRefs": [
          "ru-labour-code-112"
        ]
      },
      {
        "date": "2026-05-12",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-13",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-14",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-15",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-16",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-17",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-18",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-19",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-20",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-21",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-22",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-23",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-24",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-25",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-26",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-27",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-28",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-29",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-30",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-05-31",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-01",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-02",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-03",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-04",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-05",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-06",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-07",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-08",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-09",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-10",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-11",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-12",
        "status": "non-working",
        "sourceRefs": [
          "ru-labour-code-112"
        ]
      },
      {
        "date": "2026-06-13",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-14",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-15",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-16",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-17",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-18",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-19",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-20",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-21",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-22",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-23",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-24",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-25",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-26",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-27",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-28",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-29",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-06-30",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-01",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-02",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-03",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-04",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-05",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-06",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-07",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-08",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-09",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-10",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-11",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-12",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-13",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-14",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-15",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-16",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-17",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-18",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-19",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-20",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-21",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-22",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-23",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-24",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-25",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-26",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-27",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-28",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-29",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-30",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-07-31",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-01",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-02",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-03",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-04",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-05",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-06",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-07",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-08",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-09",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-10",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-11",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-12",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-13",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-14",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-15",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-16",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-17",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-18",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-19",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-20",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-21",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-22",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-23",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-24",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-25",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-26",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-27",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-28",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-29",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-30",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-08-31",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-01",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-02",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-03",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-04",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-05",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-06",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-07",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-08",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-09",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-10",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-11",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-12",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-13",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-14",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-15",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-16",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-17",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-18",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-19",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-20",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-21",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-22",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-23",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-24",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-25",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-26",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-27",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-28",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-29",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-09-30",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-01",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-02",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-03",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-04",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-05",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-06",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-07",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-08",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-09",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-10",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-11",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-12",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-13",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-14",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-15",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-16",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-17",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-18",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-19",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-20",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-21",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-22",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-23",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-24",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-25",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-26",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-27",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-28",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-29",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-30",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-10-31",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-01",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-02",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-03",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-04",
        "status": "non-working",
        "sourceRefs": [
          "ru-labour-code-112"
        ]
      },
      {
        "date": "2026-11-05",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-06",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-07",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-08",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-09",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-10",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-11",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-12",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-13",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-14",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-15",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-16",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-17",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-18",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-19",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-20",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-21",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-22",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-23",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-24",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-25",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-26",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-27",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-28",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-29",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-11-30",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-01",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-02",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-03",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-04",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-05",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-06",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-07",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-08",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-09",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-10",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-11",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-12",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-13",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-14",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-15",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-16",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-17",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-18",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-19",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-20",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-21",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-22",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-23",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-24",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-25",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-26",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-27",
        "status": "non-working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-28",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-29",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-30",
        "status": "working",
        "sourceRefs": []
      },
      {
        "date": "2026-12-31",
        "status": "non-working",
        "sourceRefs": [
          "ru-government-resolution-1466-2025"
        ]
      }
    ],
    "aggregates": {
      "totalDays": 365,
      "workingDays": 247,
      "nonWorkingDays": 118,
      "months": [
        {
          "month": 1,
          "workingDays": 15,
          "nonWorkingDays": 16
        },
        {
          "month": 2,
          "workingDays": 19,
          "nonWorkingDays": 9
        },
        {
          "month": 3,
          "workingDays": 21,
          "nonWorkingDays": 10
        },
        {
          "month": 4,
          "workingDays": 22,
          "nonWorkingDays": 8
        },
        {
          "month": 5,
          "workingDays": 19,
          "nonWorkingDays": 12
        },
        {
          "month": 6,
          "workingDays": 21,
          "nonWorkingDays": 9
        },
        {
          "month": 7,
          "workingDays": 23,
          "nonWorkingDays": 8
        },
        {
          "month": 8,
          "workingDays": 21,
          "nonWorkingDays": 10
        },
        {
          "month": 9,
          "workingDays": 22,
          "nonWorkingDays": 8
        },
        {
          "month": 10,
          "workingDays": 22,
          "nonWorkingDays": 9
        },
        {
          "month": 11,
          "workingDays": 20,
          "nonWorkingDays": 10
        },
        {
          "month": 12,
          "workingDays": 22,
          "nonWorkingDays": 9
        }
      ]
    }
  }
] as const
